import { FlexRow, Text, StyledSvg } from '@make-software/tg-mini-app-ui';

import {
  BaseModal,
  CloseIconButton,
  IconWrapper,
  ModalContentWrapper,
  StyledHeader, UnknownWalletContent
} from '@/shared';
import CloseIcon from '@/shared/assets/icons/ic-close.svg';
import WalletIcon from '@/shared/assets/icons/ic-wallet.svg';

import { KnownWalletContent } from './known-wallet-content';
import { ContentWindow, ButtonWrapper } from './wallet-modal.styled';

export { ContentWindow, ButtonWrapper };

interface WalletModalProps {
  unknownWallet: boolean;
  telegramName: string;
  connectedWallet: string | null;
  openModal: boolean;
  handleCloseModal: () => void;
  onConnectWallet?: () => void;
  onDisconnectWallet?: () => void;
  onDownloadWallet?: () => void;
}

export const WalletModal = ({
  openModal,
  handleCloseModal,
  unknownWallet,
  telegramName,
  connectedWallet,
  onConnectWallet,
  onDownloadWallet,
  onDisconnectWallet
}: WalletModalProps) => {
  return (
    <BaseModal
      onRequestClose={handleCloseModal}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      isOpen={openModal}
      style={{
        content: {
          inset: 'auto 0 0 0',
          padding: '0 0 20px 0',
          boxShadow: 'inset 0 0 0 1px #41424E',
          top: 'auto'
        }
      }}>
      <ModalContentWrapper direction={'column'}>
        <StyledHeader align={'center'} justify={'space-between'}>
          <FlexRow gap={8} align={'center'}>
            <IconWrapper>
              <StyledSvg src={WalletIcon} fillColor="#FFF" />
            </IconWrapper>
            <Text weight={1} size="md" color="white">
              {!unknownWallet ? 'Wallet Info' : 'Connect your wallet'}
            </Text>
          </FlexRow>
          <CloseIconButton
            iconSrc={CloseIcon}
            onClick={handleCloseModal}
            size={35}
            borderRadius="50%"
            iconColor="white"
          />
        </StyledHeader>
        {!unknownWallet && (
          <KnownWalletContent
            telegramName={telegramName}
            connectedWallet={connectedWallet}
            onDisconnectWallet={onDisconnectWallet}
            onConnectWallet={onConnectWallet}
          />
        )}
      </ModalContentWrapper>

      {unknownWallet && <UnknownWalletContent onConnectWallet={onConnectWallet} onDownloadWallet={onDownloadWallet} />}

    </BaseModal>
  );
};
